import Typography from '@mui/material/Typography';
import {formatCopy} from 'utils/typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {LinkPopover} from '@vedmarket/ui-kit';
import HelpPanel from '../../help-panel';
import DeclarationsExamplesList from './components/list';

const DeclarationExamples = ({ handleApplyCode, isExpandedDeclarationTab, code }: DeclarationExamplesProps) => {
  const { t } = useTranslation();

  const [ isExpanded, setIsExpanded ] = useState(isExpandedDeclarationTab);

  return <div className='declarations-examples'>
    <HelpPanel
      title={t('calc__text__packaging__examplesOfDeclarations')}
      expanded={isExpanded}
      onChange={setIsExpanded}
      headerHelp={<LinkPopover
        linkText={t('calc__help__declarationExamplesLink')}
        text={formatCopy(t('calc__help__declarationExamples'))}
      />}
    >
      <DeclarationsExamplesList handleApplyCode={handleApplyCode} code={code} />
    </HelpPanel>
  </div>;
};

export default DeclarationExamples;
